import { render, staticRenderFns } from "./table-body.vue?vue&type=template&id=428b507e&scoped=true"
import script from "./table-body.vue?vue&type=script&lang=ts"
export * from "./table-body.vue?vue&type=script&lang=ts"
import style0 from "./table-body.vue?vue&type=style&index=0&id=428b507e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428b507e",
  null
  
)

export default component.exports